import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FunctionsService } from '../../services/functions.service';
import { Jobs } from '../../models/jobs.model';
import Swal from 'sweetalert2';
import { HttpService } from '../../services/http.service';
import { UsersService } from '../../services/users.service';
import { CandidatesJobsApply } from '../../models/candidatesJobsApply.model';
import { CandidatesProfiles } from '../../models/candidatesProfiles.model';
import { Candidates } from '../../models/candidates.model';
import { CandidatesTrainings } from '../../models/candidatesTrainings.model';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Trainings } from '../../models/trainings.model';
import { CandidatesExperiences } from 'src/app/models/candidatesExperiences.model';
import { CandidatesCertificates } from 'src/app/models/candidatesCertificates.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-apply-job',
  templateUrl: './apply-job.component.html',
  styleUrls: ['./apply-job.component.scss']
})
export class ApplyJobComponent implements OnInit {

  baseURL = environment.apiUrl;
  @Input() jobList!: Jobs[];

  jobID: any;
  job: any;
  cover_letter: any = undefined
  curriculum_vitae: any = undefined
  applyJobIsLoading: boolean = false
  eligibiliy: boolean = false
  addTraningsFiles: boolean = false
  candidates: any
  continueWithMyCV: boolean = true
  candidatesJobsApply: any[] = []
  candidateProfiles: any[] = []
  candidateExperience: any[] = []
  experience: any[] = []
  certificat: any[] = []
  certificatList: any[] = []

  jobApplied = false;
  totalFillingRate: number = 0;
  candidateTrainingList: CandidatesTrainings[] = [];
  experienceList: CandidatesExperiences[] = [];
  candidateCertificateList: CandidatesCertificates[] = [];
  //applyJobForm: FormBuilder = new FormBuilder();
  applyJobForm: FormGroup;


  // candidates: Candidates = new Candidates([]);
  candidatesTrainings: CandidatesTrainings = new CandidatesTrainings({});
  trainingIsLoading: boolean = false;

  Array: string[] = [];
  isfrmChecked: any;

  componentMethodName(event: any, isChecked: boolean) {
    if (isChecked) {
      this.Array.push(event.target.value);
    }
    else {
      let index = this.Array.indexOf(event.target.value);
      this.Array.splice(index, 1);
    }
  }

  constructor(private functions: FunctionsService, private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private httpService: HttpService, private usersService: UsersService) {

    this.applyJobForm = this.formBuilder.group({
      certificat: this.formBuilder.array([], [Validators.required]),
      experience: this.formBuilder.array([], [Validators.required]),
      training: this.formBuilder.array([], [Validators.required]),
      availability: ['', Validators.required],
      mobility: ['', Validators.required],
      status: ['', Validators.required],
      current_salary: ['', Validators.required],
      desired_salary: ['', Validators.required]

    })

    // this.applyJobForm = new FormGroup({
    //   certificats: new FormArray([]),
    //   experiences: new FormArray([])
    // });


    if (usersService.getUserType() == 'entreprise') {
      this.router.navigate(['/accueil/entreprise']);
    } else if (usersService.getUserType() == 'admin') {
      this.router.navigate(['/admin']);
    }

    this.jobID = this.route.snapshot.paramMap.get('jobID');
    this.candidates = this.usersService.getCurrentUser();

    this.candidateProfiles = this.candidates.getCandidatesProfiles();

    this.candidatesJobsApply = (this.candidates.getCandidatesJobsApply() != null) ? this.candidates.getCandidatesJobsApply() : [];
    if (parseInt(this.jobID) != this.jobID) {
      this.router.navigate(['/not-found']);
    }
  }

  ngOnInit() {
    // console.log(this.jobID);
    // console.log(this.candidates.getToken());
    this.getCandidateTrainings();
    this.getCandidateExperiences();
    this.getCandidateCertificats();
    this.checkTrainingFile();
    this.jobApplied = this.checkJob(this.jobID);


    // console.log(this.getCandidateTrainings());
    //this.eligibiliy = this.checkProfession(this.jobcheck().getProfession()['id']);
    if (localStorage.getItem('jobList') && localStorage.getItem('jobList') != undefined) {
      let list = JSON.parse(localStorage.getItem("jobList") || "[]");

      (this.functions.searchJob(this.jobID, list) == undefined) ? this.router.navigate(['/not-found']) : this.job = this.functions.searchJob(this.jobID, list);
    } else {
      this.router.navigate(['/not-found'])
    }

    if (localStorage.getItem('totalFillingRate') != undefined) {
      const dataString: any = localStorage.getItem('totalFillingRate');
      this.totalFillingRate = JSON.parse(dataString);
    }
    console.log(this.totalFillingRate);
    this.applyold();
    localStorage.removeItem('jobIDToApply');
  }


  onCheckboxChange(e: any) {
    const experience: FormArray = this.applyJobForm.get('experience') as FormArray;

    if (e.target.checked) {
      experience.push(new FormControl(e.target.value));

      // console.log(experience);
    } else {
      const index = experience.controls.findIndex(x => x.value === e.target.value);
      experience.removeAt(index);
    }
  }

  async onCheckboxCertificatChange(e: any) {
    const certificat: FormArray = this.applyJobForm.get('certificat') as FormArray;

    if (e.target.checked) {

      certificat.push(new FormControl(e.target.value));

    } else {

      const index = certificat.controls.findIndex(x => x.value === e.target.value);

      certificat.removeAt(index);
    }
  }

  async onCheckboxTrainingChange(e: any) {
    const training: FormArray = this.applyJobForm.get('training') as FormArray;

    if (e.target.checked) {

      training.push(new FormControl(e.target.value));

    } else {
      const index = training.controls.findIndex(x => x.value === e.target.value);

      training.removeAt(index);
    }
  }
  getCandidateTrainings() {
    const candidateTraining: any = this.candidates.getCandidatesTrainings();
    this.candidateTrainingList = [];
    candidateTraining.forEach((element: any) => {
      let candidatesTrainings = new CandidatesTrainings(element);
      this.candidateTrainingList.push(candidatesTrainings);
    });
    return this.candidateTrainingList;
  }

  //check diplôme files

  checkTrainingFile() {
    for (let index = 0; index < this.getCandidateTrainings().length; index++) {

      const element = this.getCandidateTrainings()[index];
      const candidateTraninFiles = new CandidatesTrainings(element);
      if (candidateTraninFiles.getDiplomaPath() == "") {
        this.addTraningsFiles = true;
        return this.addTraningsFiles;
      }
    }
    return this.addTraningsFiles;
  }

  goToUpdateCandidateInfo() {
    localStorage.setItem('jobIDToApply', this.jobID);
    this.router.navigate(['/candidat-infos'])
  }
  goToUpdateCandidateTrainings() {
    localStorage.setItem('jobIDToApply', this.jobID);
    this.router.navigate(['/candidat-trainings'])
  }

  getCandidateExperiences() {
    const candidateExperience: any = this.candidates.getCandidatesExperiences();
    // console.log(candidateExperience);
    this.experienceList = [];

    candidateExperience.forEach((element: any) => {
      let candidatesExperiences = new CandidatesExperiences(element);
      if (candidatesExperiences.getCertificatePath() != "") {
        this.experienceList.push(candidatesExperiences);
      }
    });
    return this.experienceList;
  }

  getCandidateCertificats() {
    const candidateCertificats: any = (this.candidates.getCandidatesCertificates() != undefined) ? this.candidates.getCandidatesCertificates() : [];
    this.candidateCertificateList = [];
    candidateCertificats.forEach((element: any) => {
      let candidatesCertificats = new CandidatesCertificates(element);
      this.candidateCertificateList.push(candidatesCertificats);
    });
    return this.candidateCertificateList;
  }


  goToUpdateCandidateProfiles() {
    localStorage.setItem('jobIDToApply', this.jobID);
    this.router.navigate(['/candidat-infos'])
  }

  goToUpdateCandidateExperiences() {
    localStorage.setItem('jobIDToApply', this.jobID);
    this.router.navigate(['/candidat-experiences'])
  }
  goToUpdateCandidateCertificates() {
    localStorage.setItem('jobIDToApply', this.jobID);
    this.router.navigate(['/candidat-certificates'])
  }


  checkJob(jobID: number) {
    for (let index = 0; index < this.candidatesJobsApply.length; index++) {
      const element = this.candidatesJobsApply[index];
      const candidatesJobsApply = new CandidatesJobsApply(element);
      const job = new Jobs(candidatesJobsApply.getJobs());
      if (job.getId() == jobID) {
        return true;
      }
    }
    return false;
  }

  // checkProfession(professonID: number) {
  //   for (let index = 0; index < this.candidateProfiles.length; index++) {
  //     const element = this.candidateProfiles[index];
  //     const candidateProfiles = new CandidatesProfiles(element);
  //     const job = new Jobs(candidateProfiles.getProfessions());
  //     if (job.getId() == professonID) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  jobcheck() {
    if (localStorage.getItem('jobList') && localStorage.getItem('jobList') != undefined) {
      let list = JSON.parse(localStorage.getItem("jobList") || "[]");

      this.job = this.functions.searchJob(this.jobID, list);
      return this.job;

    }
  }

  applyold() {
    if (this.jobApplied) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: ' Désolé, vous avez déjà postulé à cette offre. Retourner sur les offres',
      });
      this.router.navigate(['/job-list'])
    }


  }


  onSubmitJobApply(): any {

    // console.log(this.candidates.getToken());

    let formValue: any = this.applyJobForm.value;

    // let formData: FormData = new FormData();
    // let formData1: FormData = new FormData();

    formValue['token'] = this.candidates.getToken();
    formValue['job_id'] = this.jobID;

    formValue['curriculum_vitae'] = this.curriculum_vitae;
    formValue['cover_letter'] = this.cover_letter;
    // formData.append('experiences', this.candidateJobCertificats);
    // formData.append('certificats', this.candidateJobExperiences);

    console.log(formValue["training"]);
    console.log(formValue["experience"]);
    console.log(formValue["certificat"]);

    if (this.continueWithMyCV == false && this.curriculum_vitae == undefined) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez joindre le nouveau CV si vous ne souhaité continuer avec votre CV par défaut.',
      });
    }
    else {
      this.applyJobIsLoading = true;

      this.httpService.applyJob(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            // let data = response.data;
            // localStorage.setItem('currentCandidate', JSON.stringify(data));
            this.applyJobIsLoading = false;
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Votre candidature a bien été prise en compte. Bonne chance!!!',
            }).then(() => {
              // console.log(localStorage.getItem('currentConsultant'));
              window.location.href = window.location.origin + "/job-list";
            });
          }
        },
        (error) => {
          console.log(error);
          this.applyJobIsLoading = false;
          if (error.error.message == 'CANDIDATE_ALREADY_APPLY_FOR_THIS_JOB') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Votre candidature a déjà été soumise pour cette offre.',
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        }
      );
    }
  }

  async chooseCoverLetter() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner le fichier',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Fichier selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.cover_letter = file;
        Swal.fire({
          icon: 'success',
          title: 'Chargement...',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  async chooseCurriculumVitae() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner le fichier',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Fichier selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.curriculum_vitae = file;
        Swal.fire({
          icon: 'success',
          title: 'Chargement...',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  showOrHideInputField(radioID: string) {
    let uploadCVField: any = document.getElementById('uploadCVField');

    if (radioID == 'withMyCV') {
      uploadCVField.style.display = "none";
      this.continueWithMyCV = true;
    } else {
      uploadCVField.style.display = "block";
      this.continueWithMyCV = false;
    }
  }
  addJobInBackup(jobID: number) {
    (this.candidates == undefined) ? this.router.navigate(['/connexion']) : this.candidates;

    const backupJobList: Jobs[] = this.candidates.getCandidatesSaveJobs();

    if (backupJobList.length == 0) {
      const jobToAdd: Jobs = this.searchJobByID(jobID);
      (jobToAdd != null) ? this.saveJob(jobID) : false;
    } else {
      if (this.checkJobInBackupList(jobID, backupJobList)) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Cette offre d\'emploi existe déjà dans vos sauvegardes.',
        })
      } else {
        const jobToAdd: Jobs = this.searchJobByID(jobID);
        (jobToAdd != null) ? this.saveJob(jobID) : false;
      }
    }
  }
  saveJob(jobID: number) {
    Swal.fire('Veuillez patientez...');
    this.httpService.saveBackupJob(jobID, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));

          Swal.fire({
            icon: 'success',
            title: 'Excellent!',
            text: 'Offre d\'emploi ajoutée à vos sauvegades',
          })
        }
      },
      (error) => {
        if (error.error.message == 'JOB_ALREADY_SAVE_WITH_THIS_CANDIDATE') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Cette offre existe déjà dans vos sauvegardes.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  checkJobInBackupList(jobID: number, backupList: Jobs[]): boolean {
    let result = false;
    backupList.forEach((element) => {
      const job = new Jobs(element);
      if (job.getId() == jobID) {
        result = true;
      }
    });

    return result;
  }

  searchJobByID(jobID: number): any {
    let jobFind;
    this.jobList.forEach((job: Jobs) => {
      if (job.getId() == jobID) {
        jobFind = job;
      }
    });

    return jobFind;
  }

}
